import React from "react";

export const mydasTitle = (
  <div>
    <i>Mydas</i>
  </div>
);

export const mydasSubtitle = (
  <div>
    "Farsa de negocios en tres actos". Suplemento de la <i>Revista de las Indias</i>, número 11
  </div>
);

export const mydasContent = (
  <div>
    <p className="content justified">
      Oswaldo Díaz Díaz publicó algunos artículos de carácter menos literario y mucho más analítico en la &nbsp;
      <em>Revista de las Indias</em> y en <em>Hojas de cultura popular colombiana</em>. <em>Mydas</em>, sin embargo, fue
      una obra teatral también conocida como <em>La jaula de cristal</em> que, al igual que <em>Blondinette</em>,
      mereció un suplemento en la revista mencionada.
    </p>
    <p className="content justified">
      Don Os también escribió en el <em>Boletín cultural y bibliográfico</em> del Banco de la República.
    </p>
    <p className="content justified">
      El 2 de noviembre de 1950 este autor fue nombrado miembro de la Academia Colombiana de Historia, y en 1955, el 27
      de mayo, como miembro número.
    </p>
  </div>
);
